import { render, staticRenderFns } from "./PrivacyPopup.vue?vue&type=template&id=0dcd8cb9&"
import script from "./PrivacyPopup.vue?vue&type=script&lang=js&"
export * from "./PrivacyPopup.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports